// Shopify Fetch
 function _addMeToCart1(e, el) {
    e = e || window.event;
    e.preventDefault();
    let variantId = el.dataset.variantid;
    let hide_modal = el.dataset.modalid;
    var modal_targ = document.getElementById("QuickAdd-" + hide_modal);
    
    if (!variantId) {
      console.error('Error: Variant ID not found');
      return;
    }

    let formData = {
      'items': [
        {
          'id': variantId,
          'quantity': 1
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((resp) => { 
      if (!resp.ok) {
        throw new Error('Network response was not ok');
      }
      
      return resp.json();
    })
    
    .then(() => {
      refreshCartDrawer();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
    })
    .catch((err) => {
      console.error('Error: ' + err);
    });

     
     // update with timeout
    setTimeout(() => {
      refreshCartDrawer();
      modal_targ.removeAttribute('open');
    }, "500");
 
   
  }

// Update function
function refreshCartDrawer() {
        // Check if cart-drawer-items exists
        let cartDrawerItems = document.querySelector('cart-drawer-items');
        var cartCount = document.getElementById('cart-count');
        var innerCount = document.getElementById('inner-count');
        // Find the cart-drawer element
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          // Remove the is-empty class from cart-drawer if it exists
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
          // Remove the div with class 'drawer__inner-empty'
          const emptyDrawerElement = cartDrawer.querySelector('.drawer__inner-empty');
          if (emptyDrawerElement) {
            emptyDrawerElement.remove();
          }
          // Make the form tag's class 'cart__contents' display as block
          const cartContentsForm = document.querySelector('.cart__contents');
          if (cartContentsForm) {
            cartContentsForm.style.display = 'block';
          }
        }
        // If cart-drawer-items doesn't exist, create it
        if (!cartDrawerItems) {
          cartDrawerItems = document.createElement('cart-drawer-items');
          // Find the drawer__header element
          const drawerHeader = document.querySelector('.drawer__header');
          if (drawerHeader) {
          // Insert the newly created cart-drawer-items after the drawer__header
          drawerHeader.insertAdjacentElement('afterend', cartDrawerItems);
          }
        }
        
        // Call the onCartUpdate method to refresh the cart drawer contents
        
        document.querySelector('cart-drawer-items').onCartUpdate();
        document.getElementById('CartDrawer-Checkout').removeAttribute('disabled');
        
        // Open the cart drawer and apply necessary classes for animation
        if (cartDrawer) {
          cartDrawer.open();
        }

        cartCount.classList.remove('hidden');
        fetch('/cart.js') // Call the fetch function passing the url of the API as a parameter
            .then(res => res.json())
            .then(function (res) {
              console.log(res.item_count);
              innerCount.innerHTML = res.item_count;
            })
            .catch(function() {
              // This is where you run code if the server returns any errors
            });

      }
